import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import React__default from 'react';
import ReactTooltip from 'react-tooltip';

const AppTooltip = props => {
  var _currentTheme$theme, _currentTheme$theme2;
  const {
    currentTheme
  } = useTheme();
  return /*#__PURE__*/React__default.createElement(ReactTooltip, _extends({
    backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.tooltipBackgroundColor,
    textColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.white,
    className: "r_tooltip",
    offset: {
      bottom: props.offsetBottom
    }
  }, props));
};
AppTooltip.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppTooltip"
};

export { AppTooltip as A };
